export function ChatPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Chat</h1>
        <p className="mt-2 text-muted-foreground">
          Start a conversation with the writing agent.
        </p>
      </div>

      <div className="rounded-lg border bg-card p-8 text-center text-card-foreground shadow-sm">
        <p className="text-muted-foreground">
          Chat interface will be implemented here.
        </p>
      </div>
    </div>
  );
}
